import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from 'src/com/sixdee/crbtportal/ui/toolkit/uicomponentcss';
import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';

export interface ListGroupRowCSSStyle extends UIComponentCSSStyle
{
  
    getGroupNameDivCSSStyle():object;
    getGroupNameLabelCSSStyle():object;
    getActionDivCSSStyle():object;
    getDeleteImgDivCSSStyle():object;
    getViewImgCSSStyle():object;
    getEditImgCSSStyle():object;
    getDeleteImgCSSStyle():object;
}

export class  ListGroupRowCSSStyleImpl extends UIComponentCSSStyleImpl implements ListGroupRowCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            width:"100%",
            borderRadius:'6px',
         
            display:'flex',
            border:' 1px solid #EAECEF',
             flexDirection:'row',
             backgroundColor:this.getResources().getColor(Colors.color_5), 
             boxShadow: "0 2px 10px 0 rgba(0,0,0,0.07)",
             flexFlow: "row wrap",
            //  marginLeft:'20%',
            //  marginRight:'20%'
           
        };
    }

    getGroupNameDivCSSStyle():object
    {
        return{
            height:'100%',display:'flex',fontFamily:this.getContext().getResources().getFontFamily()
        };
    }
  

    getGroupNameLabelCSSStyle():object
    {
        return{
            width:'100%',
            textAlign:'left',
           
            fontFamily:this.getContext().getResources().getFontFamily(),
         
            color:'#221E20',
            
            letterSpacing:'0'
        };
    }

    getActionDivCSSStyle():object
    {
        return{
           borderLeft:' 1px solid #EAECEF', height:'100%'
        };
    }


    getDeleteImgDivCSSStyle():object{
        return{
          borderLeft:' 1px solid #EAECEF',height:'100%',borderRadius:'0px 6px 6px 0px'
        };
    }
    getViewImgCSSStyle():object
    {
        return{
            marginTop:'24.7px',cursor:'pointer',
        };
    }

    getEditImgCSSStyle():object
    {
        return{
            marginTop:'20.7px',cursor:'pointer',
        };
    }
   
    getDeleteImgCSSStyle():object
    {
        return{
            marginTop:'20.7px',cursor:'pointer',
        };
    }

   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/groups/listgroup/viewmodel/grouprow/listgrouprowcss.tsx